import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { FaApple, FaFacebook, FaGoogle, FaChevronRight } from "react-icons/fa";
import { IoCaretBack } from "react-icons/io5";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
// import colors from "../config/colors";
// import { useDispatch, useSelector } from "react-redux";
// import apiClient from "../api/apiClient";
// import { login } from "../redux/counterSlice";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { AdminButton } from "../../components/mui";
import { Button } from "@mui/material";
export default () => {
  let loginState = {
    email: "",
    password: "",
  };

  const navigate = useNavigate();
  //   const [type, setType] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const [loginData, setLoginData] = useState(loginState);
  const [message, setMessage] = useState({ text: "", color: "" });
  //   const handleChange = (key, value) => {
  //     setLoginData({ ...loginData, [key]: value });
  //   };
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    accountType: "",
    requestType: "",
    state: "",
    address: "",
    Description: "",
    startDate: "",
    endDate: "",
  });
  useEffect(() => {
    document.title = "RollingAdz: Add Request" || "Default Title";
  }, []);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  //   function resetErrors() {
  //     setMessage({ text: "", color: "" });
  //   }
  //   const dispatch = useDispatch();
  //   const { isLoggedIn, userType } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (loginData.password.length < 6)
    //   return setMessage({
    //     text: "Password should be atleast 6 characters",
    //     color: "danger",
    //   });
    // console.log(loginData);
    // const result = await apiClient.post("/user/signin", loginData);
    // if (result.ok && result.data?.token) {
    //   const authToken = result.data?.token;
    //   console.log(authToken);
    //   apiClient.setHeader("Authorization", `Bearer ${authToken}`);
    //   const userInfo = await apiClient.get("/user/user-info");
    //   console.log(userInfo);
    //   dispatch(login({ token: authToken, userType: userInfo.data.role }));
    //   handleNavigate(userInfo.data.role);
    // }
  };
  function handleNavigate(role) {
    // if (role == "IN") navigate("/installeraccount");
    // else if (role == "PH") navigate("/photograperaccount");
    // else if (role == "AC") navigate("/advertiser-account");
    // else if (role == "VO") navigate("/vehicleowneraccount");
    // else if (role == 5) navigate("/driver-search-result");
  }
  const location = useLocation();
  const name = location.state;
  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  return (
    <div className="">
      {/* Signup button popup */}
      <div className=" d-flex justify-content-center align-items-center ">
        <div className="   rounded-3 col-md-6">
          <div onClick={() => navigate(-1)}>
            <BiArrowBack size={35} color={"#1976d2"} />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="login-form col-md-10 mx-auto">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="accountType-label">Account Type</InputLabel>
                    <Select
                      labelId="accountType-label"
                      id="accountType"
                      label="Account Type"
                      name="accountType"
                      value={formData.accountType}
                      onChange={handleChange}
                    >
                      <MenuItem value="VO">Vehicle Owner</MenuItem>
                      <MenuItem value="IN">Installer</MenuItem>
                      <MenuItem value="PH">Photographer</MenuItem>
                      <MenuItem value="AC">Agency</MenuItem>
                      <MenuItem value="AC">Company Direct</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="requestType-label">Request Type</InputLabel>
                    <Select
                      labelId="requestType-label"
                      id="requestType"
                      label="Request Type"
                      name="requestType"
                      value={formData.requestType}
                      onChange={handleChange}
                    >
                      <MenuItem value="Install">Install</MenuItem>
                      <MenuItem value="Removal">Removal</MenuItem>
                      <MenuItem value="Repair">Repair</MenuItem>
                      <MenuItem value="Swarm">Swarm</MenuItem>
                      <MenuItem value="Special Event">Special Event</MenuItem>
                      <MenuItem value="Photoshoot">Photoshoot</MenuItem>
                      <MenuItem value="Videoshoot">Videoshoot</MenuItem>
                      <MenuItem value="Drone">Drone</MenuItem>
                      <MenuItem value="Campaign">Campaign</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel id="state-label">State</InputLabel>
                    <Select
                      labelId="state-label"
                      id="state"
                      label="State"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                    >
                      {states.map((state, index) => {
                        return (
                          <MenuItem key={index} value={state}>
                            {state}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Address"
                    variant="outlined"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="outlined-basic"
                    label="Description"
                    variant="outlined"
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <label>Start Date:</label>
                    <input className="p-3" type="date" />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <label>End Date:</label>
                    <input className="p-3" type="date" />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <label>Start Time:</label> <br />
                    <input className="p-3" type="time" />
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div>
                    <label>End Time:</label> <br />
                    <input className="p-3" type="time" />
                  </div>
                </Grid>

                <Grid item xs={12} className="d-flex justify-content-center">
                  <Button variant="contained" color="primary" type="submit">
                    Create Request
                  </Button>
                </Grid>
              </Grid>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
